import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

// Bookmark of FontAwesome 4 (same glyph as the app): wider than the FontAwesome 6 one,
// close to TikTok's. The viewBox is cut to the glyph so it fills 1em like the other icons.
const BookmarkIcon: React.FC<SvgIconProps> = React.memo((props) => (
  <SvgIcon viewBox="0 -1408 1280 1513" {...props}>
    <path d="M116-1408L1164-1408Q1187-1408 1208-1399L1208-1399Q1241-1386 1260.5-1358Q1280-1330 1280-1296L1280-1296L1280-7Q1280 27 1260.5 55Q1241 83 1208 96L1208 96Q1189 104 1164 104L1164 104Q1116 104 1081 72L1081 72L640-352L199 72Q163 105 116 105L116 105Q93 105 72 96L72 96Q39 83 19.5 55Q0 27 0-7L0-7L0-1296Q0-1330 19.5-1358Q39-1386 72-1399L72-1399Q93-1408 116-1408L116-1408Z" />
  </SvgIcon>
));

export default BookmarkIcon;
